import { ApiErrorCode, apiErrorBodySchema, type ApiErrorBody } from "@repo/schema";

/** An RTK Query rejection (or anything shaped like one) carrying the API's error body. */
export interface ApiError {
  status: number;
  data: ApiErrorBody;
}

const statusOf = (err: unknown): number | undefined =>
  typeof err === "object" && err !== null && "status" in err && typeof err.status === "number"
    ? err.status
    : undefined;

/** True when `err` is a rejection whose body follows the API's error contract. */
export const isApiError = (err: unknown): err is ApiError =>
  statusOf(err) !== undefined &&
  apiErrorBodySchema.safeParse((err as { data?: unknown }).data).success;

/**
 * The error's code. A 5xx without a body code is Sentry's plain 500
 * (`INTERNAL`); anything else unrecognised is `UNKNOWN`.
 */
export const getApiErrorCode = (err: unknown): string => {
  if (isApiError(err)) return err.data.code;
  const status = statusOf(err);
  return status !== undefined && status >= 500 ? ApiErrorCode.INTERNAL : ApiErrorCode.UNKNOWN;
};
